import { useState, useEffect } from 'react';
import { Row, Col, Form, Radio, Space, Select, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { renderComponent } from '../../../../select/typeSelect';
import { isMobile, isMobileOnly } from 'react-device-detect';
import DownOutlinedMobile from '../../../../assets/icons/DownOutlinedMobile.svg';
import axios from 'axios';
import env from '../../../../environment';
import MortgageTermForm4 from './MortgageTermForm4';
import { InputNumber } from 'afrodita';

const { Option } = Select;
const { TabPane } = Tabs;

const DetailHoldersForm5 = ({ edit, form, subrogation }) => {
	const { t } = useTranslation();
	const lang = localStorage.getItem('i18nextLng');
	const [countries, setContries] = useState();
	const [participants, setParticipants] = useState(undefined);

	useEffect(() => {
		axios.get(`${env.api.url}/v1/countries`).then((response) => {
			setContries(response.data.data);
		});

		if (edit === undefined) {
			form.resetFields();
		}
	}, []);

	const onChange = (value) => {
		setParticipants(value);
		localStorage.setItem('participants', value);
	};
	const ownerList = [];
	for (let i = 1; i <= form.getFieldValue('participants'); i++) {
		ownerList.push(i);
	}
	const colSpan = {
		xxl: edit === undefined ? 24 : 6,
		xl: edit === undefined ? 24 : 6,
		lg: edit === undefined ? 24 : 8,
		md: edit === undefined ? 24 : 12,
		sm: 24,
		xs: 24
	};
	const participantsItems = (data, owner) => {
		return (
			<>
				{(edit === undefined || isMobile) && (
					<div className="applicant-style">{t(`onboarding.owner${data}`)}</div>
				)}
				<Col {...colSpan}>
					<Form.Item name={`activity${data}`} label={t('form.activity')} style={{ width: '100%' }}>
						<Select
							id={`activity${data}`}
							placeholder={t('form.activity')}
							suffixIcon={<img src={DownOutlinedMobile} alt="DownOutlinedMobile" />}>
							{renderComponent('activity').options.map((situation) => {
								return (
									<Option key={situation.value} value={situation.value}>
										{t(situation.label)}
									</Option>
								);
							})}
						</Select>
					</Form.Item>
				</Col>
				{subrogation !== true && (
					<>
						<Col {...colSpan}>
							<Form.Item
								name={`seniority${data}`}
								label={t('form.seniority')}
								rules={[
									{
										validator: (e, value) =>
											value < 41
												? Promise.resolve()
												: Promise.reject(
														new Error(t('form.seniority') + ' No puede ser mayor de 40')
												  )
									}
								]}>
								<InputNumber
									defaultValue={''}
									id={`seniority${data}`}
									gbType="number"
									className="gb-input-new-years"
									max={40}
									maxLength="2"
									placeholder={t('0')}
								/>
							</Form.Item>
						</Col>
						<Col {...colSpan}>
							<Form.Item
								name={`netIncomes${data}`}
								label={edit ? t('form.netIncomesOwnerInmo') : t('form.netIncomesOwner')}
								rules={[
									{
										validator: (e, value) =>
											value > 0
												? Promise.resolve()
												: Promise.reject(new Error(t('netIncomes.inputValidator')))
									}
								]}>
								<InputNumber
									id={`netIncomes${data}`}
									gbType="number"
									className="gb-input-new-netincomes"
									max={999000}
									maxLength="15"
									placeholder={'0'}
									defaultValue={''}
								/>
							</Form.Item>
						</Col>
						<Col {...colSpan}>
							<Form.Item name={`loanPayment${data}`} label={t('onboarding.haveOtherLoans')}>
								<InputNumber
									defaultValue={''}
									id={`loanPayment${data}`}
									gbType="number"
									className="gb-input-new-netincomes"
									max={99000000}
									maxLength="15"
									placeholder={'0'}
								/>
							</Form.Item>
							<div className="explination-others-incomes">{t('onboarding.leaveItAt0')}</div>
						</Col>
					</>
				)}
				{edit !== undefined && subrogation !== true && owner === 0 && (
					<MortgageTermForm4 edit={true} />
				)}
				{edit !== undefined && subrogation !== true && owner === 0 && (
					<Col {...colSpan}>
						<Form.Item name="cityzenship" label={t('form.country')}>
							<Select
								id="cityzenship"
								suffixIcon={<img src={DownOutlinedMobile} alt="DownOutlinedMobile" />}
								showSearch
								placeholder={t('form.country')}
								style={{ width: '100%' }}
								filterOption={(input, option) => {
									return (
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
										option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
									);
								}}>
								{countries &&
									countries.countries.map((paises) => {
										return (
											<Option key={paises.code} value={paises.code}>
												{lang === 'en' ? paises.name_en : paises.name_es}
											</Option>
										);
									})}
							</Select>
						</Form.Item>
					</Col>
				)}
			</>
		);
	};
	return (
		<>
			{edit === undefined && (
				<Col {...colSpan}>
					<Form.Item name="participants">
						<Radio.Group onChange={(e) => onChange(e.target.value)} id="participants">
							<Space direction="vertical">
								<Radio value={1}>
									{subrogation ? t('onboarding.buyAlone@') : t('onboarding.buyAlone')}
								</Radio>
								<Radio value={2}>
									{t(subrogation ? t('onboarding.buyWithSomeone2') : 'onboarding.buyWithSomeone')}
								</Radio>
							</Space>
						</Radio.Group>
					</Form.Item>
				</Col>
			)}
			{edit !== undefined && (
				<Col {...colSpan}>
					<Form.Item name="participants" label={t('onboarding.ownersQuestion')}>
						<Select onChange={(e) => setParticipants(e)} id="participants" value={participants}>
							<Option value={1}>
								{subrogation ? t('onboarding.buyAlone@') : t('onboarding.buyAlone')}
							</Option>
							<Option value={2}>
								{subrogation ? t('onboarding.buyWithSomeone2') : t('onboarding.buyWithSomeone')}
							</Option>
						</Select>
					</Form.Item>
				</Col>
			)}

			{edit !== undefined && !isMobileOnly && (
				<Col span={24}>
					<Tabs defaultActiveKey="1" centered>
						{form.getFieldValue('participants') &&
							ownerList.map((data, i) => {
								return (
									<TabPane tab={t(`onboarding.owner${data}`)} key={data}>
										<Row gutter={24}>{participantsItems(data, i)}</Row>
									</TabPane>
								);
							})}
					</Tabs>
				</Col>
			)}
			{form.getFieldValue('participants') !== undefined &&
				ownerList.map((data, i) => {
					if (edit === undefined || isMobile) {
						return participantsItems(data, i);
					}
				})}
		</>
	);
};

export default DetailHoldersForm5;
